import React, { FC } from "react";

import { BaseComponentProps, useIsAuthenticated, useShare } from "@keepeek/commons";
import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";

import { KHeaderWidget } from "../../../../models/configuration/components/kHeaderWidget";
import { usePageVisible } from "../../../../providers/config/hooks";
import { PagesPath } from "../../../App/utils";
import KHeaderWidgetLogo from "./KHeaderWidgetLogo";

type KheaderWidgetLinkLogo = {
  kHeaderWidgetLogo: KHeaderWidget["kHeaderWidgetLogo"];
} & BaseComponentProps;

const KheaderWidgetLinkLogo: FC<React.PropsWithChildren<KheaderWidgetLinkLogo>> = function ({
  kHeaderWidgetLogo,
  ...rest
}) {
  const { isAuthenticated } = useIsAuthenticated();
  const router = useRouter();
  const { isShare, tokenId } = useShare(router.pathname, router.query.tokenId);
  const { homeVisible, elementVisible, searchVisible } = usePageVisible();
  const { t } = useTranslation();

  if ((homeVisible || elementVisible || searchVisible) && kHeaderWidgetLogo?.link) {
    // Avoid going to landing page then return to home
    const headerLogoLink = (): string => {
      if (kHeaderWidgetLogo.link === "/" && isAuthenticated) {
        return "/home";
      }
      return kHeaderWidgetLogo?.link ?? PagesPath.HOME_PAGE;
    };
    return (
      <Link
        href={isShare ? `/share/${tokenId}` : headerLogoLink()}
        passHref
        legacyBehavior
        {...rest}
      >
        <a title={t("layout.homePageName.aria") as string} data-testid="headerLogo">
          <KHeaderWidgetLogo kHeaderWidgetLogo={kHeaderWidgetLogo} />
        </a>
      </Link>
    );
  }

  return <KHeaderWidgetLogo kHeaderWidgetLogo={kHeaderWidgetLogo} />;
};

export default KheaderWidgetLinkLogo;
